export const DDDD_MMMM_YYYY = 'dddd, MMMM D, YYYY';
export const DDD_MMM_D_YYYY = 'ddd, MMM D, YYYY';
export const YYYY_MM_DD = 'YYYY-MM-DD';
export const YY_MM_DD = 'YY-MM-DD';
export const YYYY_MM_DD_UNDERSCORE = 'YYYY_MM_DD';
export const MM_DD_YYYY = 'MM/DD/YYYY';
export const MM_DD_YYYY_TIME = 'MM/DD/YYYY h:mm:ss A';
export const M_DD_YYYY = 'M/DD/YYYY';
export const MM_DD_YYYY_DASH = 'MM-DD-YYYY';
export const MM_DD_YY = 'MM/DD/YY';
export const YYMMDD = 'YYMMDD';
export const MM_DD = 'MM/DD';
export const MMM_D_YYYY = 'MMM D, YYYY';
export const MMMM_D_YYYY = 'MMMM D, YYYY';
export const H_MM_A = 'h:mm A';
export const HH_MM_A = 'hh:mm A';
export const H_MM_SS = 'h:mm:ss';
export const MILITARY_HH_MM = 'HH:mm';
export const MILITARY_HH_MM_SS = 'HH:mm:ss';
export const H_MM_SS_A = 'h:mm:ss A';
export const M_D_H_MMA = 'M/D h:mma';
export const MMM = 'MMM';
export const DD = 'DD';
export const D = 'd';
export const DAY = 'day';
export const DAYS = 'days';
export const L = 'L';
export const CDT = 'CDT';
export const DAY_OF_WEEK = 'dd';
export const DATE_TIME_FORMAT = `${YYYY_MM_DD} ${MILITARY_HH_MM_SS}`;
export const FULL_DATE = 'dddd, MMMM Do YYYY';

// luxon formats
export const MM_DD_YYYY_HH_MM_SS = 'MM/dd/yyyy HH:mm:ss';
export const YYYY_MM_DD_HH_MM_SS = 'yyyy-MM-dd HH:mm:ss';
export const YYYY_MM_DD_HH_MM_SS_ZZ = 'yyyy-MM-dd HH:mm:ss ZZ';
export const ZZZZ = 'ZZZZ';
export const USA_DATE = 'MM/dd/yyyy';
export const YYYY_MM_DD_LUXON = 'yyyy-MM-dd';
export const H_MM_A_LUXON = 'h:mm a';
export const HH_MM_A_LUXON = 'hh:mm a';
export const LL_DD_YYYY = 'LL-dd-yyyy';

export const MM_DD_YYYY_LUXON = 'MM-dd-yyyy';
export const MM_DD_YYYY_HH_MM_LUXON = 'MM-dd-yyyy HH:mm';
export const MM_DD_YYYY_HH_MM_A_LUXON = 'MM-dd-yyyy hh:mma';
